export const storeAppId = 'f3a6e67f-850d-4dd9-960a-04c6638ded36'; // The ID for the Store app
//# sourceMappingURL=constants.js.map